import React, { useState } from "react";
import AppViewTab from "../modules/AppViewTab";
import { Routes, Route } from "react-router-dom";
import Review from "../Review";
import AppTab from "./AppTab";
import VerificationTab from "./VerificationTab";
import FooterText from "../modules/FooterText";
import ResultTab from "./ResultTab";

function ApplicationPreview() {
  const [tabs, setTabs] = useState({ personal: 0, income: 0, education: 0 });

  return (
    <div className="form-div app-review">
      <AppViewTab
        heading1={"My Application"}
        heading2={"All fields are required"}
        tabs={tabs}
        tabList={[
          { title: "Application", phase: "application" },
          { title: "Verification", phase: "verification" },
          { title: "Result", phase: "result" },
        ]}
      />
      <Routes>
        <Route
          path="/"
          element={
            <AppTab
            //   onChange={(e) => setTabs({ ...tabs, personal: e })}
            />
          }
        />
          <Route path="*" element={<AppTab />} /> 

        <Route
          path="/application"
          element={
            <AppTab
            //   onChange={(e) => setTabs({ ...tabs, personal: e })}
            />
          }
        />
        <Route
          path="/verification"
          element={
            <VerificationTab
            //   onChange={(e) => setTabs({ ...tabs, personal: e })}
            />
          }
        />{" "}
        <Route
          path="/result"
          element={
            <ResultTab
            //   onChange={(e) => setTabs({ ...tabs, personal: e })}
            />
          }
        />
      </Routes>
      <FooterText />
    </div>
  );
}

export default ApplicationPreview;
